import { Can } from 'providers/casl'

export const onViewportCUD = (can: Can) => {
  can('create', 'GlobalSetupFeature-viewport')
  can('update', 'GlobalSetupFeature-viewport')
  can('delete', 'GlobalSetupFeature-viewport')
}
